﻿﻿import { ChargeStatus } from '../enums/index';

export interface IRecipientCenterInvoiceRequest {
    donorId: number;
    recipientId: number;
    physicianChargeStatus: ChargeStatus;
    physicianChargeComments: string;
    anesthesiaChargeStatus: ChargeStatus;
    anesthesiaChargeComments: string;
    hospitalChargeStatus: ChargeStatus;
    hospitalChargeComments: string;
}
